/**
 * Classifier Tool Configurations
 *
 * Tools for NAICS, PSC, and other classification tasks.
 */ import { defineToolConfig, formatCount, hasProperty, safeString } from '../tool-display-config';
// ============================================================================
// Tool Configurations
// ============================================================================
const departmentNameClassificationConfig = defineToolConfig({
    id: 'department-name-classifier',
    aliases: [
        'departmentNameClassifier',
        'departmentNameClassifierTool'
    ],
    formatSuccess: (output)=>{
        const data = output.data;
        const count = Array.isArray(data) ? data.length : 0;
        if (count === 0) return 'No matching departments found';
        const first = data?.[0];
        if (first) {
            const deptName = safeString(first['department-name'], 'Unknown');
            const confidence = safeString(first.confidence, 'unknown');
            return `${deptName} (${confidence} confidence)`;
        }
        return `Found ${formatCount(count, 'department')}`;
    },
    formatError: (error)=>{
        if (hasProperty(error, 'message')) {
            return `Department classification failed: ${error.message}`;
        }
        return 'Failed to classify department';
    },
    formatInput: (input)=>{
        if (!input?.query) return [];
        return [
            {
                label: 'Query',
                value: input.query.slice(0, 100) + (input.query.length > 100 ? '...' : '')
            }
        ];
    },
    isValidOutput: (output)=>{
        return typeof output === 'object' && output !== null && 'data' in output && Array.isArray(output.data);
    },
    isEmptyResult: (output)=>!Array.isArray(output.data) || output.data.length === 0
});
// ============================================================================
// Export
// ============================================================================
export const classifierToolConfigs = [
    departmentNameClassificationConfig
];
